import { render } from "./kunlunCouponspayModel.vue?vue&type=template&id=05e6d648"
import script from "./kunlunCouponspayModel.vue?vue&type=script&lang=js"
export * from "./kunlunCouponspayModel.vue?vue&type=script&lang=js"

import "./kunlunCouponspayModel.vue?vue&type=style&index=0&id=05e6d648&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__